import { render } from "./StoreImovel.vue?vue&type=template&id=161b101e&scoped=true"
import script from "./StoreImovel.vue?vue&type=script&lang=js"
export * from "./StoreImovel.vue?vue&type=script&lang=js"

import "./StoreImovel.vue?vue&type=style&index=0&id=161b101e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161b101e"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBtn,QCard,QIcon,QInput,QSelect,QFile,QImg,QSpinnerDots,QInnerLoading});
